import { Box } from "@mui/material";
import React from "react";
import ContactsList from "./ContactsList";
import { useSelector } from "react-redux";

function IgnoredContacts(props) {
	const { ignored: ignoredContacts } = useSelector((state) => state.contacts);

	return (
		<Box>
			<div className="h-[72px]"></div>
			<ContactsList contactsDataList={ignoredContacts} accept={props.accept} />
		</Box>
	);
}

export default IgnoredContacts;
